export const watchUserAction = {
  invoke: {
    src: 'watchUserAction',
  },
};
